class I18nService {
  copy: { [key: string]: string } = {};

  constructor() {
    const translationContainer = document.querySelector<HTMLElement>(
      "[data-i18n]"
    );

    if (!translationContainer) return;

    const translations = translationContainer.dataset.i18n;
    translationContainer.dataset.i18n = ""; // cleanup

    if (!translations) return;

    this.copy = JSON.parse(translations);
  }

  get currentLanguage(): string {
    return document.documentElement.lang;
  }
}

// Make sure only one instance of I18nService is created
const i18nService = new I18nService();
Object.freeze(i18nService);

export { i18nService };
